$(document).ready(function() {
    $('.block--foto_switch').each(function() {
        var $block = $(this);
        var $tabs = $block.find('.switch-tab');
        var $images = $block.find('.image-wrap');
        var $select = $block.find('.foto-switch--dropdown');
        function activate(index) {
            var indexStr = String(index);
            $tabs.removeClass('active').filter('[data-index="' + indexStr + '"]').addClass('active');
            $images.removeClass('active').filter('[data-index="' + indexStr + '"]').addClass('active');
            if ($select.length && String($select.val()) !== indexStr) {
                $select.val(indexStr);
            }
        }
        $tabs.on('click', function() {
            activate($(this).attr('data-index'));
        });
        $select.on('change', function() {
            activate($(this).val());
        });
    });
});
